var project_name = process.env.VUE_APP_PROJECT_NAME;
const eidentitet_localstorage_key = "deidentitet_data_" + project_name;
export default {
    hasEIdentitetData(){
        var id = this.getEIdentitetData();
        if(id)
            return true;
        return false;
    },
    getEIdentitetData(){
        var localstorage_value = localStorage.getItem(eidentitet_localstorage_key);        
        try{
            return JSON.parse(localstorage_value);
        }
        catch {
            return false;
        }
    },
    setEIdentitetData(data)
    {
        localStorage.setItem(eidentitet_localstorage_key, JSON.stringify(data));
    },
    clear()
    {
        localStorage.removeItem(eidentitet_localstorage_key);        
    }
}